var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[(_vm.loggedIn)?[_c('Navbar')]:_vm._e(),_c('router-view'),(_vm.loggedIn)?[_c('Foot')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }